import React from "react";

import SideBanner from "components/layout/SideBanner";
import { useForgotPasswordMi } from "features/forgot-password-mi/hooks/useForgotPasswordMi";

import { Body, Container, Content } from "./ForgotPasswordMiPage.styles";

const ForgotPasswordMiPage = (): JSX.Element => {
  const { buildStep, header, step, steppers } = useForgotPasswordMi();

  return (
    <Container>
      <SideBanner activated={step} header={header} steppers={steppers} />
      <Content>
        <Body>{buildStep()}</Body>
      </Content>
    </Container>
  );
};

export default ForgotPasswordMiPage;
